import { forwardRef, memo, useImperativeHandle, useState } from "react"
import {
  Modal,
  Box,
  Typography,
  Paper,
  List,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material"
import ModalCloseButton from "../ModalCloseButton"
import T from "../../hooks/Language/T"
import InfoIcon from "@mui/icons-material/Info"
import useTranslationSharie from "../../hooks/Language/useTranslation"
import Spinner from "../../UI/Spinner/Spinner"

const FunFactsModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const t = useTranslationSharie()

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <T>
        <ModalCloseButton handleClose={handleClose} />
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 500,
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Box p={2}>
            <Typography variant='h6' gutterBottom>
              {t("Fun Facts About")} {props.skill_name}
            </Typography>
            <Divider sx={{ mb: 2 }} />

            {props.fun_facts?.length > 0 ? (
              <List dense>
                {props.fun_facts?.map((fact, index) => (
                  <ListItem key={index} alignItems='flex-start' sx={{ mb: 1 }}>
                    {fact != "" && (
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <InfoIcon color='primary' />
                      </ListItemIcon>
                    )}
                    <ListItemText
                      primary={
                        <Typography variant='body1' sx={{ whiteSpace: "pre-line" }}>
                          {fact}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Spinner />
            )}
          </Box>
        </Paper>
      </T>
    </Modal>
  )
})

export default memo(FunFactsModal)
